import React from 'react';
import PropTypes from 'prop-types';

const search = (name, filter) => {
  const obj = filter.find(o => o.category === name.toLowerCase());
  if (obj) {
    return obj.name;
  }
  return '';
};

const Buttons = props => (
  <section className="module-filter top">
    <div className="flex">
      {props.filter.map((item, i) => (
        <div className="flex filter-box" key={i}>
          <h2 id={`select-filter-${i}`} className="container-filter-h2">
            {props.language.filter[item.name.toLowerCase()]}:{' '}
            {search(item.name, props.tags) !== ''
              ? search(item.name, props.tags)
              : props.language.all}
          </h2>
          <ul className="container-filter-ul">
            <li className="container-filter-li no-padding">
              <i className="fas fa-caret-down" />
              <ul data-nonescroll="ok">
                <li>
                  <a
                    role="button"
                    tabIndex={0}
                    key={'all'}
                    data-select={'*'}
                    data-category={item.name.toLowerCase()}
                    data-parent={`select-filter-${i}`}
                    onClick={props.handleTagsFilter}
                  >
                    {props.language.all}
                  </a>
                </li>
                {item.tags.map((value, e) => (
                  <li key={e}>
                    <a
                      role="button"
                      tabIndex={0}
                      data-select={value.tag}
                      data-category={item.name}
                      data-parent={`select-filter-${i}`}
                      onClick={props.handleTagsFilter}
                    >
                      {value.tag}
                    </a>
                  </li>
                ))}
              </ul>
            </li>
          </ul>
        </div>
      ))}
    </div>
  </section>
);

export default Buttons;



// WEBPACK FOOTER //
// ./source/client/components/summary_nfa/buttons.jsx